import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, MessageCircle, PenTool, ListChecks } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-terracotta" data-id="element-158" />,
    title: 'Guía paso a paso',
    desc: 'El método explicado sin relleno. Directo al grano.'
  }, {
    icon: <MessageCircle className="w-8 h-8 text-terracotta" data-id="element-159" />,
    title: 'Guiones de conversación',
    desc: 'Qué decir exactamente para temas de rutinas, sueño y alimentación.'
  }, {
    icon: <PenTool className="w-8 h-8 text-terracotta" data-id="element-160" />,
    title: 'Plantillas rellenables',
    desc: 'Para cerrar acuerdos en papel en menos de 10 minutos.'
  }, {
    icon: <ListChecks className="w-8 h-8 text-terracotta" data-id="element-161" />,
    title: 'Checklist imprimible',
    desc: 'Tu guía rápida para las micro-reuniones diarias.'
  }];
  return <section className="py-20 px-4 bg-cream" data-id="element-162">
      <div className="max-w-6xl mx-auto" data-id="element-163">
        <div className="text-center mb-12" data-id="element-164">
          <h2 className="text-3xl md:text-4xl font-bold text-brown mb-4" data-id="element-165">
            ¿Qué incluye?
          </h2>
          <p className="text-brown-light" data-id="element-166">
            Todo lo que necesitas para empezar hoy mismo.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-167">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-blush/20 text-center hover:shadow-md transition-shadow" data-id="element-168">
              <div className="bg-blush/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-169">
                {item.icon}
              </div>
              <h3 className="font-bold text-lg text-brown mb-2" data-id="element-170">
                {item.title}
              </h3>
              <p className="text-sm text-brown-light" data-id="element-171">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}